import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { useEffect, useState } from 'react';
import { Header } from '../../Screen';

type BooleanOptions = [boolean, string][];

export const BooleanForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  onSubmitValue,
  question,
  featureName,
  setValidForSubmission,
  trueLabel = 'Yes',
  falseLabel = 'No',
}: QuestionnaireFormProps<Questionnaire, boolean> & {
  trueLabel?: string;
  falseLabel?: string;
}) => {
  const options: BooleanOptions = [
    [true, trueLabel],
    [false, falseLabel],
  ];

  const [booleanValue, setBooleanValue] = useState<boolean | undefined>(value);

  useEffect(() => {
    const validForSubmission = booleanValue !== undefined;
    setValidForSubmission(validForSubmission);
  }, [booleanValue, setValidForSubmission]);

  const handleSubmit = () => {
    if (booleanValue === undefined) {
      throw new Error(
        `[${featureName}] Boolean value is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(booleanValue);
  };

  return (
    <Header onSubmit={handleSubmit}>
      <div className="p-label-container">
        {options.map(([mappableValue, label]) => (
          <div className="mb8" key={label as string}>
            <input
              id={label as string}
              className="p-radio"
              type="radio"
              value={label as string}
              onChange={() => setBooleanValue(mappableValue as boolean)}
              checked={booleanValue === mappableValue}
            />
            <label
              htmlFor={label as string}
              className="p-label p-label--bordered"
              data-cy={`radio-${label}`}
            >
              {label}
            </label>
          </div>
        ))}
      </div>
    </Header>
  );
};
